// AI-generated HAYAT brand imagery (ivory / sand / champagne-gold, calm editorial)
const J = "/images";

export const IMAGES = {
  hero: `${J}/c5ac844c30abcb0d82399b325e993f5d6c72d4e2ee6828165d281a5ebf6af991.jpeg`,
  doctor: `${J}/72f46d793d62960627c4d05bdf171106dba8af9eb2e85db95a1bf7e9adecd6cd.jpeg`,
  lifeStages: `${J}/d46981ad828068e4cf2707d8cdee942631f03946207c38a18c9ada37fe659612.jpeg`,
  connectedCare: `${J}/27d89ff11c3385cf021095e9495e52e220998bc1fb700229f9223e2656ca8802.jpeg`,
  longevity: `${J}/3afd9d9844aa18ff6664c1b4085a88eac61ee292de9cb1b901c4e093c42d2ece.jpeg`,
  nutrition: `${J}/578e769e8c46fb601ccc7aff61f2aa181042ceb101b36afec0fb667a3f2a327a.jpeg`,
};

// Life stages — one unique image each
export const STAGE_IMAGES = {
  adolescence: `${J}/d57e572c2a0b39676203cba8906ae3ea9baa1b23603be4c0a7dbcdbde8266748.jpeg`,
  "cycle-health": `${J}/68a6ba75450f491c48f016427bcc2af44b1cf701f4ee1305a4f252197a6ab4fc.jpeg`,
  "family-planning": `${J}/2bf5b605d9cd03cb408291fa759d18062a5456533978bff04ffe6a6a37f6480d.jpeg`,
  fertility: `${J}/aec2d24a69491730482db042ba6947b0c3cd7f35dd777e55b30e1cdffb9c5e75.jpeg`,
  pregnancy: `${J}/c05c01db8cd9aa0978ef4c3d073ebc455dd5c333db5c68d69b8f156906c8c9ec.jpeg`,
  postpartum: `${J}/d34bd3c66bada9d343016d948ec6047362abee8540819a5f7118abdd1f2dcd60.jpeg`,
  perimenopause: `${J}/54460ded178fa650a16e4a145772147c5eecd17ef384702518fed505b025a13e.jpeg`,
  menopause: `${J}/1119e9676d607185a2ef87b9284d84e43ba488a405b07101421ec8e22833e4db.jpeg`,
  "healthy-aging": `${J}/3fdcb4a5daa5f546b54d5a5c51df8172568a92f53bb0a34b37ca78e5175dfb7b.jpeg`,
};

// Expertise — one unique image each
export const EXPERTISE_IMAGES = {
  "general-gynecology-and-preventive-care": `${J}/b6e028a4316133ff4e4ebfd2731546ce72e4ef6c9b0d82e239a4622f13d62da9.jpeg`,
  "hormonal-health-and-gynecological-endocrinology": `${J}/5e050affcc8e92c094758f16c865df12c2a315f02fc176c4ce417072307d0cd8.jpeg`,
  "fertility-assessment-and-infertility": `${J}/2eab4deb2a9cdf74cd4bef00d98854ab33956688958600136171bb9404749421.jpeg`,
  "clinical-nutrition": `${J}/6c743778e846e8c1d6ce1c4daf90d49ef1e08767aec3711751012395ef0294e6.jpeg`,
  longevity: `${J}/7eb20a11620b10a003b019d7d5809226a34214bae31133bac3f2bab3b1f296df.jpeg`,
  "orthomolecular-and-micronutrient-medicine": `${J}/6504bf40f1c3cfc5630cfe469a7390f0f7024c9951125a1f2185a34090d6e7d2.jpeg`,
};

// Atmospheric fallbacks for pages without a dedicated photo (calm editorial)
export const FALLBACK_IMAGES = {
  expertise: "https://images.unsplash.com/photo-1782397132123-0166b524d6bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  clinic: "https://images.pexels.com/photos/8987433/pexels-photo-8987433.jpeg?auto=compress&cs=tinysrgb&w=1400",
  atmosphere: "https://images.unsplash.com/photo-1552650272-b8a34e21bc4b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  botanical: "https://images.unsplash.com/photo-1521193089946-7aa29d1fe776?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

// Hub hero images (representative, theme-specific)
export const HUB_IMAGES = {
  lifeStages: STAGE_IMAGES.pregnancy,
  expertise: EXPERTISE_IMAGES["general-gynecology-and-preventive-care"],
  approach: IMAGES.connectedCare,
  patientService: IMAGES.hero,
  hormonalHealth: EXPERTISE_IMAGES["hormonal-health-and-gynecological-endocrinology"],
  fertilityPregnancy: STAGE_IMAGES.pregnancy,
  menopauseAging: STAGE_IMAGES.menopause,
  preventiveMedicine: EXPERTISE_IMAGES["orthomolecular-and-micronutrient-medicine"],
};
